import { Permission } from 'shared'
import CIMSTable from 'components/CIMSTable'
import { LabTech, useLabTechsContext } from './LabTechsContext'
import { useColumns } from './hooks/useColumns'
import { useCreate } from './hooks/useCreate'
import { useExpand } from './hooks/useExpand'
import { useRemove } from './hooks/useRemove'
import EditLabTechModal from './components/EditLabTechModal'
import { useCIMSModal } from 'components/CIMSModal/hooks/useCIMSModal'

const LabTechs: React.FC = () => {
  const { refetch: onReload, fetching, labTechs } = useLabTechsContext()
  const columns = useColumns()
  const expand = useExpand()
  const create = useCreate()
  const remove = useRemove()
  const [visible, toggle, tech] = useCIMSModal<LabTech>()
  return (
    <CIMSTable
      columns={columns}
      records={labTechs}
      rowKey="id"
      actions={{
        header: { onReload, create },
        row: {
          edit: {
            permission: Permission.EditLabTech,
            modal: { type: 'custom', toggle },
          },
          remove,
          help: 'Removing a Lab Tech will not remove the associated User',
        },
      }}
      loading={fetching}
      expand={expand}
    >
      <EditLabTechModal
        visible={visible}
        onClose={() => toggle(null)}
        state={tech}
      />
    </CIMSTable>
  )
}

export default LabTechs
